import { createContext } from 'react';
import {
  PLATFORM_IDS,
  PLATFORM_REGISTRY,
  type PlatformId,
} from '@kirin/api-client/contracts/platform-registry';

export const defaultReleased: ReadonlySet<PlatformId> = new Set(
  PLATFORM_IDS.filter(id => PLATFORM_REGISTRY[id].released)
);

export const PlatformReleaseContext =
  createContext<ReadonlySet<PlatformId>>(defaultReleased);
